import { AxiosError } from 'axios';
import { appToast } from 'components/Basic/CustomToast';
import { removeIndividualPanels } from 'components/tool/Editor/ButtonDiv/api';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { errorResponseHandler } from 'store/api/AxiosError';

export default function useRemovePanelsQuery() {
	const deletedPanels = useSelector((state: RootState) => state.panelSlice.data.deletedPanels);
	const { uuid, panel } = useSelector((state: RootState) => state.roofData.data);

	return useMutation(
		'remove-panels',
		async () => await removeIndividualPanels(deletedPanels, panel.key, uuid),
		{
			onError(error: AxiosError) {
				const message = errorResponseHandler(error).message;
				appToast.error(message);
			},
		});
}